import * as React from 'react';
import { makeStyles } from '@mui/styles'
import { CircularProgress } from '@mui/material';

const useStyles = makeStyles({
  loading: {
    position: 'absolute',
    top: 0,
    left: 0,
    width: '100%',
    height: '100%',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    backgroundColor: 'rgba(0,0,0,0.6)',
  },
});

type Props = {
  loading: boolean
};

function LoadingOverlay(props: Props) {
  const { loading } = props;
  const classes = useStyles();

  if (!loading) {
    return null;
  }

  return (
    <div className={classes.loading}>
      <CircularProgress />
    </div>
  );
}

export default LoadingOverlay;
